import { Component, Input } from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { OgragService } from '../ograg.service';
import { FirestoreService } from '../firestore-service.service';

@Component({
  selector: 'app-proofstatement',
  imports: [FormsModule, DecimalPipe],
  templateUrl: './proofstatement.component.html',
  styleUrl: './proofstatement.component.scss'
})
export class ProofstatementComponent {
  @Input() organizationKey: string = ""
  userStatement = "Zrównoleglanie zadań może pomóc w przyśpieszeniu realizacji innowacji"
  proofResult = ""
  proofSteps: string[] = []
  proofScore = 0
  isProofing = false
  @Input() minScore = 0.5 // minimum score to consider the statement as supported
  @Input() threshold = 0.9 // threshold to consider the statement as supported

  constructor(private ogragService: OgragService, private firestoreService: FirestoreService) {

  }


  async proofStatement() {
    this.isProofing = true
    this.proofSteps = []
    this.proofScore = 0
    this.proofResult = ""
    if (this.userStatement.trim() === "") {
      this.proofResult = "Please enter a statement to proof"
      this.firestoreService.showSnackBar("Please enter a statement to proof.")
      this.isProofing = false
      return
    }
    const result = await this.ogragService.proofStatement(this.organizationKey, this.userStatement, this.threshold )
    if (result.length === 0) {
      this.proofResult = "No evidence found for the statement."
      this.firestoreService.showSnackBar("No evidence found for the statement.")
    } else {
      this.proofResult = (result.firstTerm || "") + " => " + (result.secondTerm || "")
      this.proofScore = (result.score || 1) * (result.similarity || 1)
      if (result.relationArray && result.relationArray.length > 0) {
        this.proofSteps = result.relationArray.map((item: any) => item.value)
      } else {
        this.proofSteps = []
      }
    }
    this.isProofing = false
  }
}
